import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change() {
    this.#injectReloadFlag()
    this.#submit()
  }

  #injectReloadFlag() {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "reload"
    input.value = "1"
    this.element.closest("form").appendChild(input)
  }

  #submit() {
    this.element.closest("form").requestSubmit()
  }
}
